import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged, filter, switchMap, catchError, of, finalize, take, Subscription, takeUntil, Subject } from 'rxjs';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { PageStateService } from 'src/app/modules/services/page-state/page-state.service';
import { ServicosIniciaisService } from 'src/app/modules/services/servicos-iniciais/servicos-iniciais.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';

@Component({
  selector: 'app-form-servicos-iniciais',
  templateUrl: './form-servicos-iniciais.component.html',
  styleUrls: ['./form-servicos-iniciais.component.scss']
})
export class FormServicosIniciaisComponent implements OnInit, OnDestroy {
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  contractId: string | null = '';
  isEditMode: boolean = false;
  form!: FormGroup;
  //Escopo 
  searchControlEscopo = new FormControl();
  filteredOptionsEscopo: any[] = [];
  selectedOptionEscopo: any;
  //Tipo de servico
  searchControlTipoServico = new FormControl();
  filteredOptionsTipoServico: any[] = [];
  selectedOptionTipoServico: any;
  //Tabela 
  displayedColumns: string[] = [];
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };
  screenWidth: number = window.innerWidth;
  columnConfig = [
    { columnDef: 'escopo', header: 'Área Funcional', property: 'escopo.nome' },
    { columnDef: 'servico', header: 'Tipo Serviço', property: 'tipoServico.nome' },
    { columnDef: 'parametroDesempenho', header: 'Parâmetro', property: 'parametroDesempenho' },
    { columnDef: 'fimPrazoAtendimento', header: 'Prazo de Atendimento', property: 'fimPrazoAtendimento', customTd:true },
    { columnDef: 'valor', header: 'Valor', property: 'valor', customTd:true },
    { columnDef: 'actions', header: '', custom: true }
  ];
  canEdit: boolean = true;
  canDelete: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalPages: number = 1;
  totalElements: number = 0;
  dataSource = new MatTableDataSource<any>([]);
  subsctiptions: Subscription[] = [];  
  filterParametro:string = '';
  filterData:any;
  idServicoInicial:string | null = '';
  criterios:any = [];
  criteriosLabels!: { [key: string]: string; };
  formServicoInicial!: FormGroup;
  private destroy$ = new Subject<void>();
  constructor(

    private fb: FormBuilder,
    private snackbarService: OpenSnackbarService,
    private servicosIniciais: ServicosIniciaisService,
    private pageStateService: PageStateService,
    private pageSizeService: PageSizeService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,    
    private authService: AuthService,
    private userService: UserService,
  ) {
    this.createForm();
    this.searchValueEscopo();
    this.searchValueTipoServico();
    this.sincronizarMedidas();
    this.formServicoInicial = this.fb.group({
      nomeEscopo: [''],
      nomeTipoServico: [''],
      parametroDesempenho: [''],
      inicioPrazoAtendimento: [''],
      medidaInicioPrazoAtendimento: ['Dias'],
      fimPrazoAtendimento: [''],
      medidaFimPrazoAtendimento: ['Dias'],
      valor: [''],
      medidaValor: ['%'],
    });
    this.buildCriteriosLabels();
    this.loadUserInfo();
  }
  ngOnDestroy(): void {
    // Garante que todas as subscrições sejam encerradas para evitar memory leaks
    this.destroy$.next();
    this.destroy$.complete();
  }
sincronizarMedidas(): void {
    const medidaInicioControl = this.form.get('medidaInicioPrazoAtendimento');
    const medidaFimControl = this.form.get('medidaFimPrazoAtendimento');

    if (!medidaInicioControl || !medidaFimControl) {
      console.error('Controles de medida não encontrados no formulário.');
      return;
    }

    // A. Sincroniza FINAL com INICIAL
    medidaInicioControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(novaMedida => {
        // Usa { emitEvent: false } para evitar um loop infinito de mudança de valor
        medidaFimControl.setValue(novaMedida, { emitEvent: false });
      });

    // B. Sincroniza INICIAL com FINAL
    medidaFimControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(novaMedida => {
        // Usa { emitEvent: false } para evitar um loop infinito de mudança de valor
        medidaInicioControl.setValue(novaMedida, { emitEvent: false });
      });
  }
  ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.contractId = params.get('id');
      this.idServicoInicial = params.get('idServicoInicial');
    });
    this.getAllData();
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    const savedPageIndex = this.pageStateService.getPageState(this.router.url);
    if (savedPageIndex) {
      this.pageIndex = savedPageIndex;
    }
    this.getData(this.pageIndex);
    if(this.idServicoInicial){
      this.getServicoInicial(this.idServicoInicial);
    }
  }

  private buildCriteriosLabels(){
    this.criteriosLabels = {
      nomeEscopo:'Escopo',
      nomeTipoServico:'Tipo de Serviço',
      parametroDesempenho:'Parâmetro',
      inicioPrazoAtendimento:'Início do Prazo de Atendimento',
      medidaInicioPrazoAtendimento:'Medida Início',
      fimPrazoAtendimento:'Final do Prazo de Atendimento',
      medidaFimPrazoAtendimento:'Medida Final',
      valor:'Valor',
      medidaValor:'Medida Valor',
  
    };
    
  }
  getAllData() {

    this.servicosIniciais.getEscopos().subscribe({
      next: (res: any) => {
        this.filteredOptionsEscopo = res.content;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    });
    this.servicosIniciais.getTipoServicos().subscribe({
      next: (res: any) => {
        this.filteredOptionsTipoServico = res.content;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    });
  }
  onCheckboxKeydown($event: any) {
    const inicioPrazoAtendimentoControl = this.form.get('inicioPrazoAtendimento');
     const fimPrazoAtendimentoControl = this.form.get('fimPrazoAtendimento');
    const medidaInicioControl = this.form.get('medidaInicioPrazoAtendimento');
    const medidaFimControl = this.form.get('medidaFimPrazoAtendimento');

    if(!$event.detail.checked){
      if(medidaInicioControl){
         medidaInicioControl.setValue('Dias', { emitEvent: false });
      }
      if(medidaFimControl){
        medidaFimControl.setValue('Dias', { emitEvent: false });
      }
      if(inicioPrazoAtendimentoControl){
        inicioPrazoAtendimentoControl.setValue('', { emitEvent: false });
      }
      if(fimPrazoAtendimentoControl){
        fimPrazoAtendimentoControl.setValue('', { emitEvent: false });
      }
    }
  }
  loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }
  checkFunctionality(functionality: any) {

    if (functionality.url === '/contratos') {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any; }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }
  // Listar Registros gerais
  getData(pageIndex: number = 0) {
    this.servicosIniciais.getServicosIniciais(
      this.pageSize,
      pageIndex,
      this.sortState.sortDirection,
      this.sortState.sortProperty,
      this.contractId,
      this.filterParametro,
      this.filterData

    ).subscribe((resp: any) => {
      const { content, pageSize, totalPages, totalElements, pageNumber } = resp;
      this.dataSource.data = content;
      this.pageSize = pageSize;
      this.totalPages = totalPages;
      this.totalElements = totalElements;
      this.pageIndex = pageNumber;
    })
  }
  getServicoInicial(idServicoInicial:string){
    this.servicosIniciais.getServicoInicial(this.contractId, idServicoInicial).subscribe({
      next: (res: any) => {
        this.patchValue(res);
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    });
  }
  handleSubmit(){
    this.idServicoInicial ? this.edit() : this.create();
  }
  create() {
    const form = this.form.value;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      const validationError = this.form.errors?.['valorInvalido'];
      if (validationError) {
        this.toastService.showError(validationError.message)
        return
      }
    }
    this.loadingService.showLoading();
    this.servicosIniciais.create(form, this.contractId).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ) .subscribe(
      (response: any) => {
        this.getData();
        this.toastService.showSuccess(response.message);
        this.resetFormState();
        this.selectedOptionEscopo = '';
        this.searchControlEscopo.setValue('', { emitEvent: false });
        this.selectedOptionTipoServico = '';
        this.searchControlTipoServico.setValue('', { emitEvent: false }); 
      },
      (erro) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    )
  }
  edit(){
    const form = this.form.value;
    this.loadingService.showLoading();
    this.servicosIniciais.edit(form, this.contractId, this.idServicoInicial).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ) .subscribe(
      (response: any) => {
        this.getData();
        this.toastService.showSuccess(response.message);
        this.resetFormState();
        this.selectedOptionEscopo = '';
        this.searchControlEscopo.setValue('', { emitEvent: false });
        this.selectedOptionTipoServico = '';
        this.searchControlTipoServico.setValue('', { emitEvent: false }); 
        this.idServicoInicial = ''
      },
      (erro) => {
        if (erro.status !== 500 && erro.status) {
          this.toastService.showError(erro.error.message);
        } else {
          this.toastService.showError();
        }
      }
    )
  }
  onSortChange(sortProperty: any): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }
    this.getData();
  }

  pageChangeEvent(event: PageEvent) {
    if (this.pageSize !== event.pageSize) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getData(0);
    }

    if (this.pageIndex !== event.pageIndex) {
      return this.getData(event.pageIndex);
    }
  }

  createForm(){
    this.form = this.fb.group({
      idEscopo: [''],
      idTipoServico: [''],
      parametroDesempenho: [''],
      inicioPrazoAtendimento: [''],
      medidaInicioPrazoAtendimento: ['Dias'],
      fimPrazoAtendimento: [''],
      medidaFimPrazoAtendimento: ['Dias'],
      valor: [''],
      medidaValor: ['%'],
      periodo: [false]
    })
  }
  patchValue(data:any){
    this.form.patchValue({
      idEscopo: data.escopo.id,
      idTipoServico: data.tipoServico.id,
      parametroDesempenho: data.parametroDesempenho,
      inicioPrazoAtendimento: data.inicioPrazoAtendimento,
      medidaInicioPrazoAtendimento: data.medidaInicioPrazoAtendimento,
      fimPrazoAtendimento: data.fimPrazoAtendimento,
      medidaFimPrazoAtendimento: data.medidaFimPrazoAtendimento,
      valor: data.valor,
      medidaValor: data.medidaValor,
      periodo: data.fimPrazoAtendimento ? true : false
    })
  }
  resetFormState(): void {
    this.form.reset({
      idEscopo: '',
      idTipoServico: '',
      parametroDesempenho: '',
      inicioPrazoAtendimento: '',
      medidaInicioPrazoAtendimento: 'Dias',
      fimPrazoAtendimento: '',
      medidaFimPrazoAtendimento: 'Dias',
      valor: '',
      medidaValor: '%',
      periodo: false
    });
  
    // Marcar todos os campos como untouched e pristine
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsPristine();
      control?.markAsUntouched();
      control?.updateValueAndValidity();
    });
  }
  // TipoDeServico
  searchValueTipoServico() {
    this.searchControlTipoServico.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value),
      switchMap(value => this.servicosIniciais.getTipoServicos().pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsTipoServico = results.content;
    });
  }
  onOptionTipoServicoSelected(event: any) {
    const selectedOption = event.option.value;
    this.selectedOptionTipoServico = selectedOption;
    this.searchControlTipoServico.setValue(selectedOption.nome, { emitEvent: false }); 
    this.form.get('idTipoServico')?.setValue(selectedOption.id); 
 
    this.searchControlTipoServico.updateValueAndValidity(); 
    this.filteredOptionsTipoServico = [];
  }

  // Escopo
  searchValueEscopo() {
    this.searchControlEscopo.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value),
      switchMap(value => this.servicosIniciais.getEscopos().pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsEscopo = results.content;
    });
  }
  onOptionEscopoSelected(event: any) {
    const selectedOption = event.option.value;
    this.selectedOptionEscopo = selectedOption;
    this.searchControlEscopo.setValue(selectedOption.nome, { emitEvent: false }); // Evita disparar valueChanges
    this.form.get('idEscopo')?.setValue(selectedOption.id);  // Define id conforme necessário
    this.searchControlEscopo.updateValueAndValidity(); // Revalida o campo após seleção
    this.filteredOptionsEscopo = [];
  }
  
  onMedidaValorChange(valorSelecionado: string) {
    const campo = this.form.get('valor');
  
    if (valorSelecionado === 'Existe' || valorSelecionado === 'Não Existe') {
      campo?.reset(); 
      campo?.disable();
    } else {
      campo?.enable();
    }
  }

  toEdit(id: any): void {
    this.idServicoInicial = id;
    this.getServicoInicial(id);
  }

  openDeleteDialog(id: number): void {
       const modalTitle: string = 'Excluir';
        const modalContent: string =
          'Você tem certeza que deseja excluir este Serviço?';
    
        const dialogRef = this.dialog.open(ModalComponent, {
          data: {
            onPerformAction: this.onDeleteModalConfirm.bind(this),
            modalTitle: modalTitle,
            modalContent: modalContent,
            id: id,
          },
        });
  }
  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.servicosIniciais.deleteServico(id, this.contractId).pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (resp: any) => {
          this.openSnackBar('Serviço deletado com sucesso.', 'sucess');
          this.getData();
        }, error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        }
      })

    );
  }
  openSnackBar(description: string, type: string) {
      let classSnack = '';
      switch (type) {
        case 'sucess':
          classSnack = 'snacbar-sucess';
          break;
        case 'warning':
          classSnack = 'snacbar-warning';
          break;
        case 'error':
          classSnack = 'snacbar-error';
          break;
      }
      this._snackBar.openFromComponent(AlertComponent, {
        duration: 3000,
        panelClass: [classSnack, 'snackbar-custom'],
        data: { description: description, type: type },
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
  }

    openModalFilters(popover?: any) {
    
      let props;
      if(this.filterData ){
        props = this.filterData;
      }else{
        props = this.generatePropsFromForm(this.formServicoInicial);
      }
    
      const data = {
        type: 'servicosIniciais',
        propsServicosIniciais: props
      };
    
      const dialogRef = this.dialog.open(ModalFiltersComponent, {
        panelClass: ['filter-panel'],
        data,
      });
    
      dialogRef.afterClosed().subscribe({
        next: (data: any) => {
          if (data) {
            // Atualiza os critérios com base nos dados do modal
            this.filterData = data;
            this.criterios = this.getCriterios(data);
            this.getData();
          }
        }
      });
    }
    
    // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
    private generatePropsFromForm(form: FormGroup): any {
      const props: any = {};
      // Itera sobre os controles do FormGroup
      Object.keys(form.controls).forEach((controlName: string) => {
        const control = form.get(controlName);
    
        // Verifica se o controle tem valor e não é nulo ou vazio
        if (control && control.value !== null && control.value !== undefined && control.value !== '') {
          props[controlName] = control.value;
        }
      });
      return props;
    }
    
    getCriterios(data: any) {
      const criterios = [];
    
      // Gera os critérios de forma dinâmica, verificando os valores dos campos
      const props: any = this.generatePropsFromForm(data);
    
      for (const prop in props) {
        if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
          criterios.push(prop);
        }
      }
    
      return criterios;
    }
    criterioRemoved(event:any){
  
  
      // Lógica para remover da lista de critérios, se necessário
      this.filterData.patchValue({
        [event.criterio]: null
      });
      this.criterios = this.criterios.filter((c:any) => c !== event.criterio);
      this.getData();
    }
  applyFilter(filterValue: string) {
    this.filterParametro = filterValue;
    this.getData();
  }
  openActivateDialog(id: number): void {
    // lógica para ativar contrato
  }

  openInactivateDialog(id: number): void {
    // lógica para inativar contrato
  }
 async openDialogHistoricoServicoInicial(id: number) {
    const data = {
          type: 'servicoInicial',
          id: id,
          contracId:this.contractId,
          fieldMappings: {
          }
        }
        const modal = await this.modalCtrl.create({
          component: ModalHistoricComponent,
          componentProps: {
            data: data,
            fieldMappings: data.fieldMappings,
          },
        });
    
        modal.present();
  }
  preventNegativePaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (isNaN(Number(pasted)) || Number(pasted) < 0) {
      event.preventDefault();
    }
  }

  blockNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '—') {
      event.preventDefault();
    }
  }
  back(){
    this.router.navigate([`contrato/${this.contractId}/detalhes`]);
  }
}
